export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-superscript-f9056f33dfec1ac92a7a04ae5f62e796.svg";